<template>
  <b-container>
    <div v-if="loading" class="text-center loading-icon">
      <b-spinner v-if="loading" x-large />
    </div>
    <div v-else>
      <DetailsOverview :project-details="projectDetails" />
      <div class="mt-5" />
      <div class="d-flex flex-row">
        <DetailsTabButton
          v-for="(tab, index) in tabs"
          :key="index"
          :tab="tab"
          :current-tab="currentTab"
          class="mr-4"
          @changetab="changetab"
        />
      </div>
      <Component
        :is="currentTab"
        v-if="currentTab != 'Microdata'"
        :project-details="projectDetails"
      />
      <Modal :show-modal="microdatadialog" />
      <b-row class="mt-5 ml-2">
        <base-button
          text="Back"
          width="8rem"
          @click="$router.push('/inventory/dataset-inventory')"
        />
      </b-row>
    </div>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import DetailsOverview from '../../../components/ProjectDetails/DetailsOverview.vue';
import DetailsTabButton from '../../../components/ProjectDetails/DetailsTabButton.vue';
import ProjectDescription from '../../../components/ProjectDetails/ProjectDescription.vue';
import MethodologyTab from '../../../components/ProjectDetails/MethodologyTab.vue';
import OrganizationSponsorTab from '../../../components/ProjectDetails/OrganizationSponsorTab.vue';
import DocumentationTab from '../../../components/ProjectDetails/DocumentationTab.vue';
import ContactTab from '../../../components/ProjectDetails/ContactTab.vue';
import Modal from '../../../components/Shared/Modal.vue';

export default {
  components: {
    DetailsOverview,
    DetailsTabButton,
    ProjectDescription,
    MethodologyTab,
    OrganizationSponsorTab,
    DocumentationTab,
    ContactTab,
    Modal,
  },
  data() {
    return {
      loading: false,
      projectDetails: [],
      microdatadialog: false,
      currentTab: 'ProjectDescription',
      tabs: [
        {
          name: 'Description',
          tab: 'ProjectDescription',
        },
        {
          name: 'Methodology',
          tab: 'MethodologyTab',
        },
        {
          name: 'Organization and Sponsors',
          tab: 'OrganizationSponsorTab',
        },
        {
          name: 'Documentation',
          tab: 'DocumentationTab',
        },
        {
          name: 'Contact Information',
          tab: 'ContactTab',
        },
        {
          name: 'Get Microdata',
          tab: 'Microdata',
        },
      ],
    };
  },
  async mounted() {
    console.log('trying very much');
    try {
      this.loading = true;
      const { data } = await this.$dataset.getDatasetDetails(this.$route.params.id);
      console.log('dataSets', data);
      this.projectDetails = data;
      console.log(this.projectDetails);
      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
  methods: {
    showDataSetModal() {
      if (this.isLoggedIn) {
        this.$router.push(`/inventory/getmicrodata/${this.$route.params.id}`);
      }
      this.microdatadialog = true;
    },
    changetab(tab) {
      this.currentTab = tab;

      // redo the nested if else statement
      if (tab === 'Microdata') {
        if (this.isLoggedIn) {
          this.$router.push(`/inventory/getmicrodata/${this.$route.params.id}`);
        } else {
          this.microdatadialog = true;
        }
      } else {
        this.microdatadialog = false;
      }
    },
  },
};
</script>
